module.exports = "<div #payElement>\n  <!-- A Stripe Element will be inserted here. -->\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/products/payment/payment.component.html
// module id = A0HG
// module chunks = 1